import React from 'react';
import { clsx } from 'clsx';
import { FolderOpen, FileQuestion, Search, Users, Calendar } from 'lucide-react';
import { Button } from './Button';

interface EmptyStateProps {
  icon?: 'folder' | 'file' | 'search' | 'users' | 'calendar' | React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({
  icon = 'folder',
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  const iconMap: Record<string, typeof FolderOpen> = {
    folder: FolderOpen,
    file: FileQuestion,
    search: Search,
    users: Users,
    calendar: Calendar,
  };

  const IconComponent = typeof icon === 'string' && icon in iconMap ? iconMap[icon] : null;

  return (
    <div className={clsx('text-center py-12', className)}>
      <div className="flex justify-center mb-4">
        {IconComponent ? (
          <IconComponent className="w-12 h-12 text-gray-400" />
        ) : (
          <span className="text-gray-400">{icon}</span>
        )}
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      {description && (
        <p className="text-gray-500 mb-4 max-w-sm mx-auto">{description}</p>
      )}
      {action && (
        <Button variant="primary" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
